// extracted by mini-css-extract-plugin
module.exports = {"list":"BookmarkList_list__BNykD","shareButton":"BookmarkList_shareButton__fmg6T"};